export const shoulderIsoAbdPainText = {
  values: [
    { value: 'ShoulderIsoAbdPain', text: 'Ja', score: 1 },
    { value: 'ShoulderIsoAbdPain', text: 'Nei', score: 0 },
    { value: 'ShoulderIsoAbdPain', text: 'Ikke aktuelt', score: -1 },
  ],
};
